<template>
  <b-server-table
    :key="tableRenderKey"
    :filter-props="{
      filterMap: [{ key: 'search' }],
    }"
    :headers="internalStaffUnitHeaders"
    :request-func="internalStaffUnitList"
    @click:row="
      $router.push({
        name: 'internal-staff-unit-single',
        params: { id: $event.id },
      })
    ">
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        <span>Створити штатну одиницю</span>
      </v-btn>
    </template>
    <template #item.name="{ item }">
      {{ item?.name || '---' }}
    </template>
    <template #item.department="{ item }">
      {{ getDepartmentPath(item.department) }}
    </template>
    <template #item.position="{ item }">
      {{ item.position?.name || '---' }}
    </template>
    <template #item.staffUnitType="{ item }">
      {{ item.staffUnitType?.name || '---' }}
    </template>
    <template #item.assignedEmployee="{ item }">
      <template v-if="item.activeAssignment">
        <span class="link">{{
          getPersonName(item.activeAssignment.employee, { initials: true })
        }}</span>
      </template>
      <template v-else-if="item.upcomingAssignment">
        <v-chip color="blue" size="small" variant="tonal">
          Заплановано з
          {{ new CustomDate(item.upcomingAssignment.dateFrom).toString() }}
        </v-chip>
      </template>
      <span v-else class="text-disabled">Вакантна</span>
    </template>
    <template #item.actions="{ item }">
      <b-action-menu
        :actions="[
          {
            title: 'Редагувати',
            action: () => openUpdateDialog(item),
            icon: 'mdi-pencil',
            iconProps: {
              color: 'blue-darken-3',
            },
          },
          {
            title: 'Видалити',
            action: () => deleteItem(item.id),
            icon: 'mdi-delete-forever',
            listItemProps: {
              class: 'text-error',
            },
            iconProps: {
              color: 'error',
            },
          },
        ]">
      </b-action-menu>
    </template>
  </b-server-table>
</template>
<script lang="ts">
import { ref } from 'vue'
import { openDialog } from '@/dialog'
import { internalStaffUnitHeaders } from '@/utils/tableHeaders'
import { BActionMenu, BServerTable } from 'best-modules/components/index'
import { getPersonName } from 'best-modules/utils/helpers'
import {
  internalStaffUnitDelete,
  internalStaffUnitList,
} from '@/requests/internalStaffUnit'
import { CustomDate } from 'best-modules/utils'
import router from '@/router'
import { InternalStaffUnit } from '@/utils/types/internalStaffUnit'

type StaffUnitDepartment = {
  name: string
  parent?: StaffUnitDepartment | null
}

export default {
  name: 'InternalStaffUnitList',
  components: { BActionMenu, BServerTable },
  data: () => ({
    internalStaffUnitHeaders,
    CustomDate,
  }),
  methods: {
    internalStaffUnitList,
    getPersonName,
    getDepartmentPath(department: StaffUnitDepartment | null) {
      if (!department) return '---'
      const parts = []
      let current = department
      while (current) {
        parts.unshift(current.name)
        current = current.parent
      }
      return parts.join(' / ')
    },
  },
  setup() {
    const tableRenderKey = ref(1)

    const openCreateDialog = () => {
      openDialog({
        name: 'InternalStaffUnit',
        action: 'create',
        params: {
          title: 'Створити штатну одиницю',
          submitLabel: 'Створити',
          cb: (staffUnit: InternalStaffUnit) => {
            router.push({
              name: 'internal-staff-unit-single',
              params: { id: staffUnit.id },
            })
          },
        },
        dialogData: {},
      })
    }

    const openUpdateDialog = (item: InternalStaffUnit) => {
      openDialog({
        name: 'InternalStaffUnit',
        action: 'update',
        params: {
          title: 'Редагувати штатну одиницю',
          submitLabel: 'Змінити',
          cb: () => (tableRenderKey.value += 1),
        },
        dialogData: { itemData: item },
      })
    }

    const deleteItem = (id: number) => {
      return internalStaffUnitDelete(id).then(() => {
        tableRenderKey.value += 1
      })
    }

    return {
      openCreateDialog,
      openUpdateDialog,
      deleteItem,
      tableRenderKey,
    }
  },
}
</script>
